var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContacted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F9E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.6667V17.5694C20 17.0242 19.6681 16.5339 19.1619 16.3314L17.8058 15.789C17.1619 15.5314 16.4281 15.8104 16.118 16.4307L16 16.6667C16 16.6667 14.3333 16.3333 13 15C11.6667 13.6667 11.3333 12 11.3333 12L11.5693 11.882C12.1896 11.5719 12.4686 10.8381 12.211 10.1942L11.6686 8.83815C11.4661 8.33194 10.9758 8 10.4306 8H9.33333C8.59695 8 8 8.59695 8 9.33333C8 15.2244 12.7756 20 18.6667 20C19.403 20 20 19.403 20 18.6667Z",
    fill: "#D84CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacted);
export default __webpack_public_path__ + "static/media/contacted.403c3b6eed4989a832add2869c2d8f48.svg";
export { ForwardRef as ReactComponent };